import React from 'react'
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Add from '@mui/icons-material/Add';

import { RedirectForm } from './RedirectForm';
import { TriggerForm } from './TriggerForm';
import { FormType } from './FormType';
import { ensureArray } from '../../../../utils/validateResponseApi.js';
import { ACTION_TYPE_OPTIONS } from '../../constants/interface.constants';

export const ManageActions = ({ values, errorInputs, listActions, handleInputChange, handleDirectInputChange, handleAdd, t }) => {
    const handleRedirectData = React.useCallback((obj) => {
        handleDirectInputChange('config', obj);
    }, [handleDirectInputChange])

    const handleTriggerData = React.useCallback((obj) => {
        handleDirectInputChange('trigger', obj);
    }, [handleDirectInputChange])

    const handleFormdData = React.useCallback((obj) => {
        handleDirectInputChange('form', obj);
    }, [handleDirectInputChange])

    const handleFileNameChange = (value) => {
        const cleanValue = value.replace(/[^A-Za-z0-9_]/g, '');
        const finalValue = cleanValue ? `${cleanValue}{date}` : '{date}';
        handleDirectInputChange('name_file', finalValue);
    };

    const getBaseFileName = (fileName) => fileName?.replace('{date}', '') || '';

    return (
        <Box>
            <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                <Grid size={{xs:10, sm:10}}>
                    <Typography variant='h6' component='h6'>{t("common.actions")}</Typography>
                </Grid>
                {listActions &&
                    <Grid                         
                        size={{xs:2, sm:'auto'}}         
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "flex-start", sm: "flex-end" },
                            gap: 1
                        }}
                    >
                        <Tooltip title={t("add")}>
                            <IconButton onClick={handleAdd}>
                                <Add />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                }
            </Grid>

            <Grid container spacing={2}>
                <Grid size={{xs:12, sm:6}}>
                    <TextField fullWidth required size="small" variant="outlined" name="accion" label={t('interface.actionName')}
                        value={values?.accion || ''}
                        onChange={handleInputChange}
                        error={!!errorInputs.accion?.isError}
                        helperText={errorInputs.accion?.messageError}
                    />
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <TextField required fullWidth size="small" variant="outlined" name="icon" label={t('interface.icon')} 
                        value={values?.icon || ''}
                        onChange={handleInputChange}
                        error={!!errorInputs.icon?.isError}
                        helperText={errorInputs.icon?.messageError}
                    />
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <TextField required fullWidth size="small" variant="outlined" name="color" label='Color'
                        value={values?.color || ''}
                        onChange={handleInputChange}
                        error={!!errorInputs.color?.isError}
                        helperText={errorInputs.color?.messageError}
                    />
                </Grid>
                {values?.type === 'detailsTable' &&
                    <Grid size={{xs:12, sm:6}}>
                        <TextField required fullWidth size="small" variant="outlined" name="badge" label='Badge'
                            value={values?.badge || ''}
                            onChange={handleInputChange}
                            error={!!errorInputs.badge?.isError}
                            helperText={errorInputs.badge?.messageError}
                        />
                    </Grid>
                }

                <Grid size={{xs:12, sm:6}}>
                    <FormControl fullWidth required size="small"
                        error={Boolean(errorInputs.type?.isError)}
                    >
                        <InputLabel id="type">{t('commonFields.type')}</InputLabel>
                        <Select name="type" label="Tipo"
                            value={values?.type || ''}
                            onChange={handleInputChange}
                        >
                            {ACTION_TYPE_OPTIONS.map((option) => <MenuItem key={option.value} value={option.value} sx={{ fontWeight: 'bold' }}>{option.label}</MenuItem> )}
                        </Select>
                        {errorInputs.type?.isError && <FormHelperText>{errorInputs.type.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <TextField fullWidth size="small" variant="outlined" name="iconHover" label={t('interface.iconHover')}
                        value={values?.iconHover || ''}
                        onChange={handleInputChange}
                    />
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <TextField fullWidth size="small"
                        label={`Visible ${t('commonFields.condition')}`}
                        placeholder={t('interface.visibleHelper')}
                        value={values?.visible || ''}
                        onChange={(e) => handleDirectInputChange('visible', e.target.value)}
                        helperText="Ej: '{status}' !== 'inactive'"
                    />
                </Grid>
                
                {values?.type === 'download' && (
                    <Grid size={{ xs:12, sm:6 }}>
                        <TextField
                            fullWidth
                            size="small"
                            label={t('commonFields.nameFile')}
                            placeholder="Reporte_Eventos"
                            value={getBaseFileName(values?.name_file)}
                            onChange={(e) => handleFileNameChange(e.target.value)}
                            helperText={t('commonFields.nameFileHelper')}
                        />
                    </Grid>
                )}

                <Grid size={{ xs: 12 }}>
                    {values?.type === 'Redirect' && (
                        <RedirectForm
                            values={values?.config || {}}
                            onFieldsChange={handleRedirectData}
                        />
                    )}

                    {values?.type === 'form' && (
                        <FormType
                            values={values?.form || []}
                            onFieldsChange={handleFormdData}
                            t={t}
                        />
                    )}

                    {(values?.type === 'form' || values?.type === 'trigger' || values?.type === 'download') && (
                        <TriggerForm values={ensureArray(values?.trigger)[0]} errorInputs={{}} onFieldsChange={handleTriggerData} t={t} />
                    )}
                    {/* {(values?.type === '') && (
                        <TriggerForm values={ensureArray(values?.trigger)[0]} errorInputs={{}} onFieldsChange={handleTriggerData} t={t} />
                    )} */}
                </Grid>
            </Grid>
        </Box>
    );
}
